import { resolveFileUrl } from "@/lib/api";

/**
 * Row of EPI/consignes pictograms - displayed systematically in the
 * "EPI & consignes obligatoires sur le site" block of the SOP sheet.
 * Fetched dynamically: images are served from our storage, but which ones
 * appear (and their order/labels) is driven live by the "Pictogrammes"
 * sheet (row 3 checkboxes) via GET /api/reference/all -> ppe_pictograms.
 */
export default function PpePictogramsRow({ pictograms }) {
  if (!pictograms || pictograms.length === 0) return null;
  return (
    <div className="flex flex-wrap gap-3 pb-3 mb-3 border-b border-border" data-testid="ppe-pictograms-row">
      {pictograms.map((p) => (
        <div
          key={p.slug}
          className="flex flex-col items-center gap-1 w-16"
          data-testid={`ppe-pictogram-${p.slug}`}
        >
          <img
            src={resolveFileUrl(p.image_url)}
            alt={p.label}
            crossOrigin="anonymous"
            className="h-12 w-12 rounded-full object-contain"
          />
          <span className="text-[8px] text-center leading-tight text-muted-foreground">{p.label}</span>
        </div>
      ))}
    </div>
  );
}
